function initVacatureApply() {
	if (document.documentElement.dataset.applyInit) return;
	document.documentElement.dataset.applyInit = "true";

	document.addEventListener("click", (event) => {
		const open = event.target.closest("[data-apply-open]");
		if (open) {
			document.getElementById(open.dataset.applyOpen)?.showModal();
			return;
		}
		const dialog = event.target.closest(".vacature-apply-dialog");
		if (event.target.closest("[data-apply-close]") || event.target === dialog) dialog?.close();
	});

	const dialog = document.querySelector(".vacature-apply-dialog");
	if (dialog?.querySelector(".gform_validation_error, .validation_error")) dialog.showModal();
	if (window.jQuery) {
		window.jQuery(document).on("gform_post_render", () => {
			const current = document.querySelector(".vacature-apply-dialog");
			if (current?.querySelector(".gform_validation_error, .gform_validation_errors") && !current.open) current.showModal();
		});
	}
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", initVacatureApply);
} else {
	initVacatureApply();
}
